import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button, Typography } from '@mui/material';
import { PatchType } from '../../../types';

interface BulkUpdateDialogsProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  pendingPatchType: PatchType | null;
  getPatchTypeDisplayName: (patchType: PatchType) => string;
}

const BulkUpdateDialogs: React.FC<BulkUpdateDialogsProps> = ({
  open,
  onClose,
  onConfirm,
  pendingPatchType,
  getPatchTypeDisplayName,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    aria-labelledby='confirmation-dialog-title'
    aria-describedby='confirmation-dialog-description'
  >
    <DialogTitle id='confirmation-dialog-title'>Change Patch Type</DialogTitle>
    <DialogContent>
      <DialogContentText id='confirmation-dialog-description'>
        You have unsaved changes. Are you sure you want to change the patch type?
        {pendingPatchType && (
          <Typography component='span' sx={{ display: 'block', mt: 1 }}>
            Changing to: <strong>{getPatchTypeDisplayName(pendingPatchType)}</strong>
          </Typography>
        )}
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} color='primary'>
        Cancel
      </Button>
      <Button onClick={onConfirm} color='primary' autoFocus>
        Confirm
      </Button>
    </DialogActions>
  </Dialog>
);

export default BulkUpdateDialogs; 